function kindCheck(checked: boolean, onChange: () => void, label: string) {
  return (
    <label className="flex cursor-pointer items-center gap-1.5 text-[11px] text-fg">
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        aria-label={label}
      />
      {label}
    </label>
  );
}

// Choosing one kind clears the other. The panel treats a second click on the
// same kind as turning the choice off.
export function SoilSampleKindChoice(props: {
  kind: "zones" | "points" | null;
  onPick: (kind: "zones" | "points") => void;
}) {
  const { kind, onPick } = props;
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-1">
      {kindCheck(kind === "zones", () => onPick("zones"), "Use zone samples")}
      {kindCheck(
        kind === "points",
        () => onPick("points"),
        "Use point samples",
      )}
    </div>
  );
}
